"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _outdatedBrowserInfo = require("./outdatedBrowserInfo");
Object.keys(_outdatedBrowserInfo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _outdatedBrowserInfo[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _outdatedBrowserInfo[key];
        }
    });
}); //# sourceMappingURL=index.js.map
